// extracted by mini-css-extract-plugin
export default {"container":"endpointurl_container__NXNFc","method":"endpointurl_method__DrMi3","endpoint":"endpointurl_endpoint__Tzs0z"};